module.exports = __webpack_public_path__ + "img/10_mke_20250515_csorgedezesesaradas_68.43bde058.jpg";